import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class AppLoginSubjectQueryCriteriaClass extends BaseCriteriaModel {
  // app_login_subject
  name?: Optional<string> = Optional.empty();
  description?: Optional<string> = Optional.empty();
  category?: Optional<string> = Optional.empty();

  // app_login_subject_ext
  login_subject_guid?: Optional<string> = Optional.empty();
  ext_type?: Optional<string> = Optional.empty();
  ext_code?: Optional<string> = Optional.empty();
  ext_option?: Optional<string> = Optional.empty();
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
}

export class AppLoginSubjectCriteriaModelQuery {
  query = '';

  constructor(appLoginSubjectCriteriaModel: AppLoginSubjectQueryCriteriaClass) {

    if (!appLoginSubjectCriteriaModel) {
      return;
    }

    this.query += appLoginSubjectCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += appLoginSubjectCriteriaModel.description.filter(x => x !== '').map(x => '&description=' + x).orElse('');
    this.query += appLoginSubjectCriteriaModel.category.filter(x => x !== '').map(x => '&category=' + x).orElse('');

    this.query += appLoginSubjectCriteriaModel.login_subject_guid.filter(x => x !== '').map(x => '&login_subject_guid=' + x).orElse('');
    this.query += appLoginSubjectCriteriaModel.ext_type.filter(x => x !== '').map(x => '&ext_type=' + x).orElse('');
    this.query += appLoginSubjectCriteriaModel.ext_code.filter(x => x !== '').map(x => '&ext_code=' + x).orElse('');
    this.query += appLoginSubjectCriteriaModel.ext_option.filter(x => x !== '').map(x => '&ext_option=' + x).orElse('');
    this.query += appLoginSubjectCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += appLoginSubjectCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += appLoginSubjectCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');

    this.query += '&status=' + appLoginSubjectCriteriaModel.status;
    this.query += '&orderBy=' + appLoginSubjectCriteriaModel.orderBy;
    this.query += '&order=' + appLoginSubjectCriteriaModel.order;
    this.query += '&offset=' + appLoginSubjectCriteriaModel.offset + '&limit=' + appLoginSubjectCriteriaModel.limit;
  }
}
